
import React from 'react';
import WaitlistSection from '../components/WaitlistSection';

const PrinterOwnerView: React.FC = () => {
  return (
    <div className="bg-background min-h-screen">
      <section className="max-w-[1400px] mx-auto border-x border-border p-12 lg:p-24 bg-white">
        <div className="max-w-3xl">
          <span className="text-[10px] font-mono text-secondary uppercase tracking-[0.2em] mb-4 block">Node Network</span>
          <h2 className="text-5xl md:text-7xl font-display tracking-tight text-primary uppercase leading-none mb-8">
            Monetize Your <br/>Idle Machines.
          </h2>
          <p className="text-secondary text-lg mb-12 max-w-xl">
            Join the distributed manufacturing revolution. Earn passive income by connecting your 3D printers to the Zetra network.
          </p>
          <button className="bg-primary text-white px-10 h-16 rounded-full text-xs font-bold uppercase tracking-widest hover:bg-neutral-800 transition-all shadow-xl">
            Register your node
          </button>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto border-x border-border border-y bg-neutral-50 grid md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-border">
        {[
          { t: 'Set Your Own Rates', d: 'You decide the price per gram and material. We take a flat 5% fee.', i: 'lucide:coins' },
          { t: 'Verified Status', d: 'Complete a sample print to earn the "Verified Node" badge and get more traffic.', i: 'lucide:shield-check' },
          { t: 'Zetra Connect App', d: 'Manage orders, material inventory, and payouts from one simple dashboard.', i: 'lucide:layout-dashboard' }
        ].map((item, idx) => (
          <div key={idx} className="p-12 space-y-4 hover:bg-white transition-colors">
            <iconify-icon icon={item.i} class="text-3xl text-primary"></iconify-icon>
            <h3 className="font-bold text-primary uppercase text-sm tracking-wide">{item.t}</h3>
            <p className="text-sm text-secondary leading-relaxed">{item.d}</p>
          </div>
        ))}
      </section>

      <section className="max-w-[1400px] mx-auto border-x border-border p-12 lg:p-24 bg-white">
        <div className="grid lg:grid-cols-2 gap-24 items-center">
          <div className="space-y-8">
            <h2 className="text-3xl font-display uppercase tracking-tight">How it works for owners</h2>
            <div className="space-y-6">
              {[
                { n: '1', t: 'Hardware Connect', d: 'Sync your printers via OctoPrint, Mainsail, or Zetra Hub.' },
                { n: '2', t: 'Auto-Bidding', d: 'Our system automatically routes jobs to you based on your material availability.' },
                { n: '3', t: 'Print & Ship', d: 'Pack the finished part in Zetra-branded eco-packaging and schedule a pickup.' },
                { n: '4', t: 'Instant Payouts', d: 'Funds are released to your wallet as soon as the customer confirms receipt.' }
              ].map((step, idx) => (
                <div key={idx} className="flex gap-6">
                  <span className="flex-shrink-0 w-8 h-8 rounded-full border border-border flex items-center justify-center font-mono text-xs">{step.n}</span>
                  <div>
                    <h4 className="font-bold text-primary uppercase text-[10px] tracking-widest mb-1">{step.t}</h4>
                    <p className="text-xs text-secondary leading-relaxed">{step.d}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="relative aspect-square rounded-[3rem] bg-neutral-900 overflow-hidden p-12 flex items-center justify-center">
            <div className="absolute inset-0 opacity-20 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:20px_20px]"></div>
            <div className="text-center text-white space-y-4 relative z-10">
               <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-neutral-500">Node Status</span>
               <div className="text-5xl font-display">ACTIVE</div>
               <div className="h-1 w-24 bg-green-500 mx-auto rounded-full"></div>
               <p className="text-xs text-neutral-400">3 Printers Connected • 14 Orders Completed</p>
            </div>
          </div>
        </div>
      </section>
      <WaitlistSection />
    </div>
  );
};

export default PrinterOwnerView;
